import { createMuiTheme } from '@material-ui/core/styles'

const systemFontStack = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'

const shippopTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#009EFF',
      dark: '#306FB1',
      contrastText: '#FFFFFF',
      light: '#EDF4FC'
    },
    secondary: {
      main: '#FFFFFF',
    },
    text: {
      primary: '#404041',
    }
  },
  typography: {
    fontFamily: systemFontStack,
    fontWeightRegular: 400,
    fontSize: 14,
  },
  spacing: 8,
  systemFont:  {
    fontFamily: systemFontStack,
  },
  headerFont: {
    fontFamily: `Kanit, ${systemFontStack}`,
  },
  props: {
    MuiLink: {
      underline: 'none',
    },
    MuiPopover: {
      disableScrollLock: true,
    }
  }
})

shippopTheme.overrides.MuiOutlinedInput = {
  root: {
    '& $notchedOutline': {
      borderColor: '#E0E0E0',
    },
    '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
      borderColor: shippopTheme.palette.primary.main,
    },
    '& input::placeholder': {
      color: '#828282',
    },
    '&.Mui-disabled': {
      backgroundColor: '#F5F5F5',
      '& $notchedOutline': {
        borderColor: '#E0E0E0',
      }
    }
  },
}

shippopTheme.overrides.MuiContainer = {
  root: {
    [shippopTheme.breakpoints.down('xs')]: {
      paddingLeft: 18,
      paddingRight: 18,
    }
  }
}

shippopTheme.overrides.MuiInputLabel = {
  root: {
    color: '#828282',
  }
}

shippopTheme.overrides.MuiTimelineDot = {
  root: {
    backgroundColor: 'red',
  }
}

shippopTheme.overrides.MuiLink = {
  root: {
    color: shippopTheme.palette.primary.main,
    '&:hover': {
      color: shippopTheme.palette.primary.dark,
    },
    cursor: 'pointer',
  }
}

shippopTheme.overrides.MuiMenuItem = {
  root: {
    paddingTop: 12,
    paddingBottom: 12,
    minWidth: 190,
    fontSize: 14,
    '&:hover': {
      backgroundColor: shippopTheme.palette.primary.main,
      color: 'white',
    },
    '&.danger': {
      color: shippopTheme.palette.error.main,
      '&:hover': {
        backgroundColor: shippopTheme.palette.error.main,
        color: 'white',
      }
    }
  }
}

shippopTheme.homeStyle = {
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  title: {
    fontSize: 32,
    fontWeight: 500,
    ...shippopTheme.headerFont,
    margin: `${shippopTheme.spacing(3)}px 0 ${shippopTheme.spacing(3)}px`,
    textAlign: 'center',
    lineHeight: 1.3,
    [shippopTheme.breakpoints.down('xs')]: {
      fontSize: 28,
      margin: `${shippopTheme.spacing(3)}px 0 ${shippopTheme.spacing(5)}px`,
    }
  },
  subtitle: {
    fontWeight: 400,
    fontSize: 18,
    margin: `${shippopTheme.spacing(2)}px 0 ${shippopTheme.spacing(3)}px`,
    color: '#828282',
    textAlign: 'center',
    [shippopTheme.breakpoints.down('xs')]: {
      fontSize: 16,
      margin: `${shippopTheme.spacing(1)}px 0 ${shippopTheme.spacing(5)}px`,
    }
  },
  topic: {
    fontWeight: 400,
    fontSize: 22,
    ...shippopTheme.headerFont,
    color: '#404041',
    margin: `${shippopTheme.spacing(2)}px 0`,
  },
  desc: {
    fontWeight: 400,
    fontSize: 16,
    color: '#828282',
    margin: `${shippopTheme.spacing(1)}px 0`,
    textAlign: 'center',
  },
  bodyText: {
    fontWeight: 400,
    fontSize: 16,
    color: '#404041',
  },
  heroTitle: {
    ...shippopTheme.headerFont,
    fontWeight: 500,
    fontSize: 52,
    color: 'white',
    lineHeight: 1.3,
    [shippopTheme.breakpoints.down('xs')]: {
      fontSize: 40,
    }
  },
  heroSubtitle: {
    fontWeight: 400,
    fontSize: 16,
    color: 'white',
    [shippopTheme.breakpoints.down('xs')]: {
      fontSize: 16,
    }
  },
  heroImageHeightDesktop: 350,
  heroImageHeightMobile: 350,
  button: {
    width: '100%',
    height: 50,
    [shippopTheme.breakpoints.up('sm')]: {
      width: 'auto',
      minWidth: 200,
      height: 50,
    }
  },
  sectionPadding: `${shippopTheme.spacing(2)}px ${shippopTheme.spacing(2)}px`,
  headerHeightDesktop: 66,
  headerHeightMobile: 59,
  boxShadow: {
    boxShadow: '3px 3px 12px -1px rgb(0 0 0 / 10%), 0px 1px 1px 0px rgb(0 0 0 / 0%), 0px 1px 3px 0px rgb(0 0 0 / 0%)',
  }
}

shippopTheme.homeStyle.section = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  padding: shippopTheme.homeStyle.sectionPadding,
}

export default shippopTheme
